import { FaTrash, FaUserCircle } from "react-icons/fa";
import stringToColor from "string-to-color";
import { ITeamMembership } from "../../api/services/team.service";
import StatusBadge from "../shared/StatusBadge";

export default function MemberList({
  users,
  deleteUser,
}: {
  users: ITeamMembership[];
  deleteUser: (userId: string) => void;
}) {
  return (
    <div className="flex flex-col overflow-y-scroll overscroll-auto space-y-2 max-h-44">
      {users.map((user, i) => (
        <div
          key={i}
          className={`flex items-center border px-4 pr-2 py-2 transition-colors ease-in-out justify-between rounded-md `}
        >
          <div className="flex items-center">
            <FaUserCircle
              className="w-8 h-8 bg-white rounded-full"
              color={stringToColor(user.userId)}
            />
            <span
              className={`ml-2 block truncate font-semibold text-slate-700`}
            >
              {user.user.firstname} {user.user.lastname}
            </span>
            <span className={`ml-2 block truncate text-slate-400 text-sm`}>
              {user.user.email}
            </span>
          </div>
          <div className="flex space-x-6">
            <StatusBadge status={user.role} />
            <div
              className="text-indigo-600 mr-2 hover:text-orange-600 rounded-xl transition-colors ease-in-out duration-200 cursor-pointer"
              onClick={(event) => {
                event.stopPropagation();
                deleteUser(user.userId);
              }}
            >
              <FaTrash size={20} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
